var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UI / Settingsicons / Flagge / English") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 10,
    cy: 10,
    r: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-/-Settingsicons-/-Flagge-/-English",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-+-Rectangle-+-Rectangle-Mask"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#0052B4",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(2.118307, 1.618307)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(8.381693, 8.381693) rotate(-135.000000) translate(-8.381693, -8.381693) ",
    x: 7.02818909,
    y: -2.11830701,
    width: 2.70700779,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(8.381693, 8.381693) rotate(-225.000000) translate(-8.381693, -8.381693) ",
    x: 7.02818909,
    y: -2.11830701,
    width: 2.70700779,
    height: 21
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D80027",
    transform: "translate(13.888134, 5.982188) rotate(-135.000000) translate(-13.888134, -5.982188) ",
    x: 13.4428844,
    y: 0.718982652,
    width: 1,
    height: 10.5264099
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D80027",
    transform: "translate(6.797027, 14.370001) rotate(-135.000000) translate(-6.797027, -14.370001) ",
    x: 6.35177695,
    y: 9.60486524,
    width: 1,
    height: 9.53027094
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D80027",
    transform: "translate(6.129999, 6.297027) rotate(-225.000000) translate(-6.129999, -6.297027) ",
    x: 5.65833969,
    y: 1.50548137,
    width: 1,
    height: 9.58309066
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D80027",
    transform: "translate(14.379067, 13.212040) rotate(-225.000000) translate(-14.379067, -13.212040) ",
    x: 13.9074079,
    y: 7.72621025,
    width: 1,
    height: 10.9716596
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(10.500000, 10.000000) rotate(-90.000000) translate(-10.500000, -10.000000) ",
    x: 7.84723484,
    y: -0.5,
    width: 5.30553033,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 7.84723484,
    y: 0,
    width: 5.30553033,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D80027",
    x: 9.1464961,
    y: 0,
    width: 2.70700779,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D80027",
    transform: "translate(10.500000, 10.000000) rotate(-90.000000) translate(-10.500000, -10.000000) ",
    x: 9.1464961,
    y: -0.5,
    width: 2.70700779,
    height: 21
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.7b02ab3cbd68f4d9cc9e52211c0e9bb0.svg";
export { ForwardRef as ReactComponent };